// Frequencies
export var ScheduleObjectFrequency;
(function (ScheduleObjectFrequency) {
    ScheduleObjectFrequency["Daily"] = "daily";
    ScheduleObjectFrequency["Weekly"] = "weekly";
    ScheduleObjectFrequency["Interval"] = "interval";
})(ScheduleObjectFrequency || (ScheduleObjectFrequency = {}));
// Days of the Week
export var ScheduleObjectDay;
(function (ScheduleObjectDay) {
    ScheduleObjectDay["Sunday"] = "Sunday";
    ScheduleObjectDay["Monday"] = "Monday";
    ScheduleObjectDay["Tuesday"] = "Tuesday";
    ScheduleObjectDay["Wednesday"] = "Wednesday";
    ScheduleObjectDay["Thursday"] = "Thursday";
    ScheduleObjectDay["Friday"] = "Friday";
    ScheduleObjectDay["Saturday"] = "Saturday";
})(ScheduleObjectDay || (ScheduleObjectDay = {}));
//# sourceMappingURL=Scheduler.js.map